"use client";

import { IconList } from "@decibeltrade/react-icons";
import { css, cva } from "styled-system/css";

import { useClaimableRewardsCount } from "@/contexts/queries/rewards/use-claimable-rewards-count";

export function NavMenuIcon({ halo }: { halo: "canvas" | "primary" }) {
  const count = useClaimableRewardsCount();

  return (
    <span className={wrapperStyles}>
      <IconList />
      {count > 0 && (
        <span aria-hidden className={dotStyles({ halo })} data-testid="nav-menu-claim-dot" />
      )}
    </span>
  );
}

const wrapperStyles = css({ position: "relative", display: "inline-flex" });

const dotStyles = cva({
  base: {
    position: "absolute",
    top: "0",
    right: "-2",
    w: "[7px]",
    h: "[7px]",
    rounded: "full",
    bg: "tag.text.gold",
  },
  variants: {
    halo: {
      canvas: { boxShadow: "[0 0 0 4px token(colors.background.canvas)]" },
      primary: { boxShadow: "[0 0 0 4px token(colors.background.primary)]" },
    },
  },
});
